<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link class="navbar-item" aria-label="Go back to Home" :to="isLoggedIn ? '/dashboard' : '/'">
        <img src="../assets/logo.png" alt="logo" width="100" height="34">
      </router-link>

      <a role="button" @click="switchMenu()" :class="{ 'is-active': menuActive }" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div :class="{ 'is-active': menuActive }" @click="switchMenu()" class="navbar-menu">
      <div class="navbar-end">
        <router-link v-if="!isLoggedIn" class="navbar-item" to="/">
          Home
        </router-link>
        <router-link v-if="isLoggedIn" class="navbar-item" to="/dashboard">
          Dashboard
        </router-link>
        <router-link v-if="isLoggedIn" class="navbar-item" to="/point">
          Point
        </router-link>
        <router-link v-if="isLoggedIn" class="navbar-item" to="/settings">
          Settings
        </router-link>
        <div v-if="isLoggedIn" class="navbar-item">
          <button class="button is-primary" @click="logout()">
            Log Out
          </button>
        </div>
        <div v-if="!isLoggedIn" class="navbar-item">
          <router-link class="button is-primary" to="/login">
            Log In
          </router-link>
        </div>
        <div v-if="!isLoggedIn" class="navbar-item">
          <router-link class="button" to="/register">
            Register
          </router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data: () => {
    return {
      menuActive: false
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.state.authToken !== null
    }
  },
  methods: {
    switchMenu () {
      this.menuActive = !this.menuActive
    },
    async logout () {
      await this.$store.dispatch('setAuthToken', null)
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.navbar {
  box-shadow: 0 0 4px 0px rgba(0, 0, 0, 0.27);
}
</style>
